import { useContext, useEffect } from "react";
import { Grid, Container, Box, Fade } from "@mui/material";
import { NavBar, CardHomePage } from "../../components";
import OsiImage from "../../utils/images/OSI.png";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

export const HomePage = () => {
  const navigate = useNavigate();
  const { isClient } = useContext(AuthContext);

  useEffect(() => {
    if (isClient) {
      navigate("/proposal");
    }
  }, [isClient, navigate]);

  const cards = [
    {
      id: 0,
      title: "3D Wellbore",
      description: "Create a 3D wellbore based on survey data.",
      image: `${process.env.REACT_APP_SERVER}/assets/img/common/3d_wellbore.jpg`,
      action: () => {
        window.open("https://3dwellbore.com/", "_blank");
      },
    },
    {
      id: 1,
      title: "OSI",
      description: "Go to the mainpage",
      image: OsiImage,
      action: () => {
        window.open("https://www.odessaseparator.com/", "_blank");
      },
    },
    {
      id: 2,
      title: "Technical Designs",
      description: "Create a Technical Design",
      image: `${process.env.REACT_APP_SERVER}/assets/img/common/tech_design.jpg`,
      action: () => navigate("/tech/all"),
    },
    {
      id: 3,
      title: "Sand Simulator",
      description: "Simulate real conditions",
      image: `${process.env.REACT_APP_SERVER}/assets/img/common/sand_simulator.png`,
      action: () => navigate("/sim/sand"),
    },
    {
      id: 4,
      title: "Gas Simulator",
      description: "Simulate real conditions",
      image: `${process.env.REACT_APP_SERVER}/assets/img/common/gas_simulator.jpg`,
      action: () => navigate("/sim/gas"),
    },
    {
      id: 5,
      title: "Pressure Simulator",
      description: "Simulate real conditions",
      image: `${process.env.REACT_APP_SERVER}/assets/img/common/press_simulator.jpg`,
      action: () => navigate("/sim/press"),
    },
  ];

  return (
    <>
      <NavBar title="Home" buttons={[]} />
      <Box
        sx={{
          marginTop: "80px",
          minHeight: "calc(100vh - 80px)",
          background:
            "linear-gradient(135deg, rgba(241, 236, 231, 0.8) 0%, rgba(241, 236, 231, 0.4) 100%)",
          padding: { xs: 2, md: 4 },
          transition: "margin-left 0.3s ease-in-out",
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={4} justifyContent="center">
            {cards.map((card, index) => (
              <Grid
                item
                lg={4}
                md={6}
                sm={12}
                xs={12}
                key={card.id}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Fade
                  in={true}
                  timeout={1000 + index * 200}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <Box sx={{ width: "100%", maxWidth: 345 }}>
                    <CardHomePage card={card} />
                  </Box>
                </Fade>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};
